export const INCOME_SALARY_CATEGORY = 9;
export const INCOME_RENTAL_CATEGORY = 11;
export const INCOME_RENTAL = 23;
export const INCOME_REGULAR_OVERTIME_CATEGORY = 8;
export const INCOME_REGULAR_OVERTIME_TYPE = 18;
